import { Component } from "@angular/core";
import { CommonModule, Location } from '@angular/common';
import { RouteValidatorService } from "src/app/core/services/route-validator.service";
import { PdpComponent } from "../pdp/pdp.component";
import PdpRedesignComponent from "../pdp-redesign/pdp-redesign.component";

@Component({
  selector: 'app-products',
  standalone: true,
  imports: [
    CommonModule,
    PdpComponent,
    PdpRedesignComponent
  ],
  templateUrl: './product-detail.component.html',
})
export class ProductDetailComponent {

  public isMigrated: boolean = false;

  constructor(private location: Location, private routeValidatorService: RouteValidatorService){
    this.isMigrated = this.routeValidatorService.isAEMMigratedPage(this.location.path());
    
  }

}